/* AUDIT Paket A+ (Runde 2, 29.09.2026): A+ Inhalte der Produktseite.
   1) Variantenwechsel ohne Neuladen: Das Theme feuert "variant:change" (bubbles) am Produktformular. Jede A+-Section trägt je Variante
      einen Schlüssel ihrer Modul-Liste (data-mf-ap-map). Ändert sich der Schlüssel, wird nur der Inhalt der Section über die Section
      Rendering API (?section_id=…&variant=…) nachgeladen und ersetzt; ohne Module wird die Section ausgeblendet.
   2) Eyecatcher: Bewegung nur, solange sichtbar; Pause-Knopf (WCAG 2.2.2); bei prefers-reduced-motion keine Bewegung.
   3) Markengeschichte: Pfeile für Maus und Tastatur, Wischen per Touch. */
(function () {
  'use strict';
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { e.target.classList.toggle('is-an', e.isIntersecting && !reduce); });
  }, { threshold: 0.2 }) : null;

  function initInhalt(root) {
    root.querySelectorAll('[data-mf-ap-luft]').forEach(function (el) {
      if (el.__mfap) return; el.__mfap = 1;
      if (io) io.observe(el); else if (!reduce) el.classList.add('is-an');
      var b = el.querySelector('.mf-ap-luft__ruhe');
      if (b) b.addEventListener('click', function () {
        var ruhe = el.classList.toggle('is-ruhe');
        b.setAttribute('aria-pressed', ruhe ? 'true' : 'false');
        b.setAttribute('aria-label', ruhe ? 'Bewegung starten' : 'Bewegung anhalten');
      });
    });
    root.querySelectorAll('[data-mf-ap-band]').forEach(function (w) {
      if (w.__mfap) return; w.__mfap = 1;
      var band = w.querySelector('.mf-ap-mg__band'); if (!band) return;
      var zur = w.querySelector('[data-richtung="-1"]'), vor = w.querySelector('[data-richtung="1"]');
      function stand() {
        var max = band.scrollWidth - band.clientWidth - 2;
        if (zur) zur.disabled = band.scrollLeft <= 2;
        if (vor) vor.disabled = band.scrollLeft >= max;
      }
      [zur, vor].forEach(function (btn) {
        if (!btn) return;
        btn.addEventListener('click', function () {
          var karte = band.querySelector('li:not(.mf-ap-mg__start)') || band.querySelector('li');
          var schritt = karte ? karte.getBoundingClientRect().width + 12 : band.clientWidth * 0.8;
          band.scrollBy({ left: schritt * parseInt(btn.getAttribute('data-richtung'), 10), behavior: reduce ? 'auto' : 'smooth' });
        });
      });
      band.addEventListener('scroll', stand, { passive: true });
      window.addEventListener('resize', stand);
      stand();
    });
  }

  function wechsel(root, vid) {
    var mapEl = root.querySelector('[data-mf-ap-map]'); if (!mapEl) return;
    var map; try { map = JSON.parse(mapEl.textContent); } catch (e) { return; }
    var key = map[String(vid)];
    if (key === undefined) return;            /* Variante gehört nicht zu diesem Produkt (z. B. Schnellkauf eines anderen Artikels) */
    var tok = root.__tok = (root.__tok || 0) + 1;
    if (key === root.getAttribute('data-key')) { root.hidden = !key; return; }
    if (!key) { root.setAttribute('data-key', ''); root.hidden = true; return; }
    var cache = root.__cache || (root.__cache = {});
    function einsetzen(html) {
      if (tok !== root.__tok) return;         /* inzwischen wurde eine andere Variante gewählt */
      var ziel = root.querySelector('[data-mf-ap-inhalt]'); if (!ziel) return;
      ziel.innerHTML = html;
      root.setAttribute('data-key', key);
      root.hidden = false;
      initInhalt(root);
    }
    if (cache[key]) { einsetzen(cache[key]); return; }
    var u = new URL(window.location.href);
    u.searchParams.set('variant', String(vid));
    u.searchParams.set('section_id', root.getAttribute('data-section-id'));
    fetch(u.toString(), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (t) {
        var d = new DOMParser().parseFromString(t, 'text/html');
        var neu = d.querySelector('[data-mf-ap-inhalt]');
        if (!neu) return;
        cache[key] = neu.innerHTML;
        einsetzen(neu.innerHTML);
      })
      .catch(function () { /* Netzfehler: der bisherige Inhalt bleibt stehen */ });
  }

  function start() { document.querySelectorAll('[data-mf-ap]').forEach(initInhalt); }
  document.addEventListener('variant:change', function (e) {
    var v = e.detail && e.detail.variant;
    if (!v || !v.id) return;
    document.querySelectorAll('[data-mf-ap]').forEach(function (root) { wechsel(root, v.id); });
  });

  /* 4) MF-HEATMAP E6 (21.10.2026): Bilder im A+-Bereich antippbar (Großansicht). Hotjar 30 Tage: Galerie Halloween-Glas 26 Taps,
     Vergleichsbild 6 mm 7, 187er-Galerie 5, jeweils ohne Wirkung. Overlay schließt per Tippen, Knopf oder Esc. */
  var SEL = '[data-mf-ap] .mf-ap-pic img, [data-mf-ap] .mf-ap-mg__karte img, [data-mf-ap] .mf-ap-mg__raster img';
  var zoomEl = null, zuletzt = null;
  function grossesBild(img) {
    var src = img.currentSrc || img.src || '';
    var best = src, bestW = 0;
    (img.getAttribute('srcset') || '').split(',').forEach(function (t) {
      var p = t.trim().split(/\s+/), w = parseInt(p[1], 10) || 0;
      if (p[0] && w > bestW) { bestW = w; best = p[0]; }
    });
    if (bestW < 1200) best = best.replace(/([?&]width=)\d+/, '$11600');
    return best;
  }
  function zu() {
    if (!zoomEl) return;
    zoomEl.hidden = true;
    document.documentElement.style.overflow = '';
    if (zuletzt && zuletzt.focus) zuletzt.focus();
  }
  function auf(img) {
    if (!zoomEl) {
      var st = document.createElement('style');
      st.textContent = SEL.split(',').map(function (x) { return x.trim(); }).join(',') + '{cursor:zoom-in}' +
        '.mf-ap-zoom{position:fixed;inset:0;z-index:2147483000;background:rgba(0,0,0,.88);display:flex;align-items:center;justify-content:center;padding:16px}' +
        '.mf-ap-zoom[hidden]{display:none}.mf-ap-zoom img{max-width:100%;max-height:100%;object-fit:contain;border-radius:12px;background:#fff}' +
        '.mf-ap-zoom button{position:absolute;top:12px;right:12px;width:44px;height:44px;border:0;border-radius:50%;background:#fff;color:#1a1a1a;font-size:26px;line-height:44px;cursor:pointer}';
      document.head.appendChild(st);
      zoomEl = document.createElement('div');
      zoomEl.className = 'mf-ap-zoom';
      zoomEl.setAttribute('role', 'dialog');
      zoomEl.setAttribute('aria-modal', 'true');
      zoomEl.setAttribute('aria-label', document.documentElement.lang.indexOf('de') === 0 ? 'Bild in groß' : 'Large image');
      zoomEl.innerHTML = '<img alt=""><button type="button" aria-label="' + (document.documentElement.lang.indexOf('de') === 0 ? 'Schließen' : 'Close') + '">&times;</button>';
      zoomEl.addEventListener('click', zu);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') zu(); });
      document.body.appendChild(zoomEl);
    }
    var z = zoomEl.querySelector('img');
    z.src = grossesBild(img);
    z.alt = img.alt || '';
    zuletzt = document.activeElement;
    zoomEl.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    zoomEl.querySelector('button').focus();
  }
  document.addEventListener('click', function (e) {
    var img = e.target.closest && e.target.closest(SEL);
    if (!img || img.closest('a, button')) return;
    e.preventDefault();
    auf(img);
  });
  if (document.querySelector('[data-mf-ap]')) {
    var cur = document.createElement('style');
    cur.textContent = SEL.split(',').map(function (x) { return x.trim(); }).join(',') + '{cursor:zoom-in}';
    document.head.appendChild(cur);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
